export default __webpack_public_path__ + "static/media/he.f831a28f.jpg";